const BASE_URL = "https://firebasestorage.googleapis.com/v0/b/elaraby-photographer.appspot.com/o"

const engagement1 = `${BASE_URL}/engagements%2Fengagement%20(1).webp?alt=media&token=d7840648-c904-41d2-b2a5-a36e1dbe6c9b`
const engagement2 = `${BASE_URL}/engagements%2Fengagement%20(2).webp?alt=media&token=125a3684-fab3-41e5-92c8-d6efc14c5e7c`
const engagement3 = `${BASE_URL}/engagements%2Fengagement%20(3).webp?alt=media&token=ea687b23-5489-4dbd-8d71-918a374167d3`
const engagement4 = `${BASE_URL}/engagements%2Fengagement%20(4).webp?alt=media&token=c687e2f9-9766-4e4d-9586-1c2f057c6e25`
const engagement5 = `${BASE_URL}/engagements%2Fengagement%20(5).webp?alt=media&token=f2c53129-3fb0-482b-8973-57d47ca495cc`
const engagement6 = `${BASE_URL}/engagements%2Fengagement%20(6).webp?alt=media&token=f5cf444c-9d20-4762-b67c-928204b30907`
const engagement7 = `${BASE_URL}/engagements%2Fengagement%20(7).webp?alt=media&token=5cbd4569-274b-4ba7-a1b5-2d37977205c1`
const engagement8 = `${BASE_URL}/engagements%2Fengagement%20(8).webp?alt=media&token=800eacbc-aa98-453a-981c-e7e72740cff9`
const engagement9 = `${BASE_URL}/engagements%2Fengagement%20(9).webp?alt=media&token=561cfa37-c691-49eb-9933-e17bf0d7f346`
const engagement10 = `${BASE_URL}/engagements%2Fengagement%20(10).webp?alt=media&token=a73fdb6f-41f1-4a3b-a929-4a22930a1840`
const engagement11 = `${BASE_URL}/engagements%2Fengagement%20(11).webp?alt=media&token=a2c94670-b8af-4c68-ad50-c3d7c674a3b6`
const engagement12 = `${BASE_URL}/engagements%2Fengagement%20(12).webp?alt=media&token=08c42e80-0137-4ba8-af7b-39be2cd97d3a`
const engagement13 = `${BASE_URL}/engagements%2Fengagement%20(13).webp?alt=media&token=cd73a03d-2aeb-4abf-9234-f678499ffbbd`
const engagement14 = `${BASE_URL}/engagements%2Fengagement%20(14).webp?alt=media&token=eb7d77c0-ae5b-46cd-8b69-0e1f8a7a1896`
const engagement15 = `${BASE_URL}/engagements%2Fengagement%20(15).webp?alt=media&token=539806b7-139d-44a6-a231-2006bb4c9479`
const engagement16 = `${BASE_URL}/engagements%2Fengagement%20(16).webp?alt=media&token=17937970-d044-41b0-96a2-a146357f3331`
const engagement17 = `${BASE_URL}/engagements%2Fengagement%20(17).webp?alt=media&token=c1c533e9-bbf8-46b6-af1a-336960bd6c22`
const engagement18 = `${BASE_URL}/engagements%2Fengagement%20(18).webp?alt=media&token=665ff003-c449-4323-b5fc-a75907d7d282`
const engagement19 = `${BASE_URL}/engagements%2Fengagement%20(19).webp?alt=media&token=bef1d4b7-1653-4a9b-ad0d-8c34d9155de5`
const engagement20 = `${BASE_URL}/engagements%2Fengagement%20(20).webp?alt=media&token=a8641e6c-909b-408a-8450-44b1696cb85e`
const engagement21 = `${BASE_URL}/engagements%2Fengagement%20(21).webp?alt=media&token=4424ae00-5137-4910-abf2-62cace17e62f`
const engagement22 = `${BASE_URL}/engagements%2Fengagement%20(22).webp?alt=media&token=8b07f4a4-6b7c-4c8f-a756-52fea8a9e994`
const engagement23 = `${BASE_URL}/engagements%2Fengagement%20(23).webp?alt=media&token=ad16fe55-2d4d-400a-af13-eff73e66b803`
const engagement24 = `${BASE_URL}/engagements%2Fengagement%20(24).webp?alt=media&token=7c95ce27-ee38-4887-8383-bb5ecf329ed1`
const engagement25 = `${BASE_URL}/engagements%2Fengagement%20(25).webp?alt=media&token=dbc72f09-a1df-494a-8685-9f2f15075d0d`
const engagement26 = `${BASE_URL}/engagements%2Fengagement%20(26).webp?alt=media&token=2e1fa8d0-1cee-4a59-ae61-d669e4c60a27`
const engagement27 = `${BASE_URL}/engagements%2Fengagement%20(27).webp?alt=media&token=ac1c7fd6-8881-4c69-b19d-a9fdb12f5369`
const engagement28 = `${BASE_URL}/engagements%2Fengagement%20(28).webp?alt=media&token=bdf026e9-4ef4-4b49-84fb-2a3994f9c7bd`
const engagement29 = `${BASE_URL}/engagements%2Fengagement%20(29).webp?alt=media&token=3fcf3f24-dd98-4f23-a864-f8b61e3b0dec`
const engagement30 = `${BASE_URL}/engagements%2Fengagement%20(30).webp?alt=media&token=992872c4-7c12-448b-a6fd-87621fc82b09`
const engagement31 = `${BASE_URL}/engagements%2Fengagement%20(31).webp?alt=media&token=3ed8c719-0dee-4111-b894-a9c5b1a27495`
const engagement32 = `${BASE_URL}/engagements%2Fengagement%20(32).webp?alt=media&token=f06872d6-0ffe-4c08-ab8d-6cba7d54dbcc`
const engagement33 = `${BASE_URL}/engagements%2Fengagement%20(33).webp?alt=media&token=8b13b821-d32e-40c4-b05c-b210dce43092`
const engagement34 = `${BASE_URL}/engagements%2Fengagement%20(34).webp?alt=media&token=e63323b0-2bd8-4d48-abbc-d49ee9851c7c`
const engagement35 = `${BASE_URL}/engagements%2Fengagement%20(35).webp?alt=media&token=a63b2bf9-1384-4048-b1a7-e7fcf3f07929`
const engagement36 = `${BASE_URL}/engagements%2Fengagement%20(36).webp?alt=media&token=da2fe0ee-d97d-4b34-b66a-c5a4c477cb0f`
const engagement37 = `${BASE_URL}/engagements%2Fengagement%20(37).webp?alt=media&token=190f6538-c71a-4c69-bc1f-666fe8d64c46`

const kid1 = `${BASE_URL}/kids%2Fkid%20(1).webp?alt=media&token=68e15ff0-692b-44f0-ac6b-c0fed67dfec7`
const kid2 = `${BASE_URL}/kids%2Fkid%20(2).webp?alt=media&token=a1d7d414-47e5-46de-ac44-2925180ed3ec`
const kid3 = `${BASE_URL}/kids%2Fkid%20(3).webp?alt=media&token=c0e2b639-67e6-4f27-90c3-d90d71dd06b5`
const kid4 = `${BASE_URL}/kids%2Fkid%20(4).webp?alt=media&token=dd6a64db-453e-4e67-93fb-3a57228d2935`
const kid5 = `${BASE_URL}/kids%2Fkid%20(5).webp?alt=media&token=583d272b-d776-4703-ae1a-7960a9af6168`
const kid6 = `${BASE_URL}/kids%2Fkid%20(6).webp?alt=media&token=3b372c91-e565-4c8a-8c0b-0bef1e8e2802`
const kid7 = `${BASE_URL}/kids%2Fkid%20(7).webp?alt=media&token=a8c182a8-0dd8-418f-90c0-37c9ce5b6ff5`
const kid8 = `${BASE_URL}/kids%2Fkid%20(8).webp?alt=media&token=d7775ab0-ee73-4f70-ba69-d4216b001f8b`
const kid9 = `${BASE_URL}/kids%2Fkid%20(9).webp?alt=media&token=59fdab6b-82ec-4077-a003-2aed79262fe8`
const kid10 = `${BASE_URL}/kids%2Fkid%20(10).webp?alt=media&token=511b2624-739c-45eb-bef0-f1ab622d516b`
const kid11 = `${BASE_URL}/kids%2Fkid%20(11).webp?alt=media&token=bc92e907-83a7-4e77-9d62-e29f91188742`
const kid12 = `${BASE_URL}/kids%2Fkid%20(12).webp?alt=media&token=a681a900-5866-4244-8a50-652eac523914`

const wedding1 = `${BASE_URL}/weddings%2Fwedding%20(1).webp?alt=media&token=07362d5e-0d61-434d-8be7-c781e898c55a`
const wedding2 = `${BASE_URL}/weddings%2Fwedding%20(2).webp?alt=media&token=4f6baa9b-9f48-486c-bdaf-5613d0b29673`
const wedding3 = `${BASE_URL}/weddings%2Fwedding%20(3).webp?alt=media&token=50d674e9-bac8-4146-9809-6a6f86a77f71`
const wedding4 = `${BASE_URL}/weddings%2Fwedding%20(4).webp?alt=media&token=ad7bf8a1-cbad-48f5-af45-b10db5dd38ea`
const wedding5 = `${BASE_URL}/weddings%2Fwedding%20(5).webp?alt=media&token=48905a85-7b95-4055-8eb8-ef2b870ec211`
const wedding6 = `${BASE_URL}/weddings%2Fwedding%20(6).webp?alt=media&token=5b88dba5-55ea-4d06-99f0-938467710e47`
const wedding7 = `${BASE_URL}/weddings%2Fwedding%20(7).webp?alt=media&token=f7a9f310-062f-4979-9442-b0f68a5a49ed`
const wedding8 = `${BASE_URL}/weddings%2Fwedding%20(8).webp?alt=media&token=55b3932b-a45d-4e2f-8297-623c9a681bb9`
const wedding9 = `${BASE_URL}/weddings%2Fwedding%20(9).webp?alt=media&token=13f8a911-e2ac-4cd8-b260-1962120358fa`
const wedding10 = `${BASE_URL}/weddings%2Fwedding%20(10).webp?alt=media&token=148c4b28-73a9-41c5-b1e5-b2fd52685d41`
const wedding11 = `${BASE_URL}/weddings%2Fwedding%20(11).webp?alt=media&token=5e072c15-8dbd-49e2-bebb-451de910f61b`
const wedding12 = `${BASE_URL}/weddings%2Fwedding%20(12).webp?alt=media&token=afb750b4-cc20-4a43-8026-414b94c013e9`
const wedding13 = `${BASE_URL}/weddings%2Fwedding%20(13).webp?alt=media&token=5b28196f-b802-4179-b43a-295af587f0c8`
const wedding14 = `${BASE_URL}/weddings%2Fwedding%20(14).webp?alt=media&token=45c034c0-7172-431d-a0ff-b6cf813f1157`
const wedding15 = `${BASE_URL}/weddings%2Fwedding%20(15).webp?alt=media&token=2a577d76-322e-474c-95f8-d5638f1a5ce2`
const wedding16 = `${BASE_URL}/weddings%2Fwedding%20(16).webp?alt=media&token=de6a1053-2516-4fdb-8d2c-818471018973`
const wedding17 = `${BASE_URL}/weddings%2Fwedding%20(17).webp?alt=media&token=8913bbba-961c-4561-8411-f696abc5db43`
const wedding18 = `${BASE_URL}/weddings%2Fwedding%20(18).webp?alt=media&token=c4cb6299-c511-4397-b6ce-ede9bf211ee2`
const wedding19 = `${BASE_URL}/weddings%2Fwedding%20(19).webp?alt=media&token=4db58b5a-d93e-49df-9fb4-60511a0cd259`
const wedding20 = `${BASE_URL}/weddings%2Fwedding%20(20).webp?alt=media&token=6f3d029b-e2e7-4c5b-a919-71ffdfac9ffd`
const wedding21 = `${BASE_URL}/weddings%2Fwedding%20(21).webp?alt=media&token=a4d3a10a-2930-4dc8-a29d-57005d4e17f1`
const wedding22 = `${BASE_URL}/weddings%2Fwedding%20(22).webp?alt=media&token=c77db4e6-ecfa-4714-9bd8-3550d152118b`
const wedding23 = `${BASE_URL}/weddings%2Fwedding%20(23).webp?alt=media&token=85ccc617-beea-4644-96b8-49f5b4839264`
const wedding24 = `${BASE_URL}/weddings%2Fwedding%20(24).webp?alt=media&token=bf346efc-71c3-4a1c-a1f1-e56c4f680bbc`

export const engagements = [
    engagement1,
    engagement2,
    engagement3,
    engagement4,
    engagement5,
    engagement6,
    engagement7,
    engagement8,
    engagement9,
    engagement10,
    engagement11,
    engagement12,
    engagement13,
    engagement14,
    engagement15,
    engagement16,
    engagement17,
    engagement18,
    engagement19,
    engagement20,
    engagement21,
    engagement22,
    engagement23,
    engagement24,
    engagement25,
    engagement26,
    engagement27,
    engagement28,
    engagement29,
    engagement30,
    engagement31,
    engagement32,
    engagement33,
    engagement34,
    engagement35,
    engagement36,
    engagement37,
]

export const kids = [
    kid1,
    kid2,
    kid3,
    kid4,
    kid5,
    kid6,
    kid7,
    kid8,
    kid9,
    kid10,
    kid11,
    kid12,
]

export const weddings = [
    wedding1,
    wedding2,
    wedding3,
    wedding4,
    wedding5,
    wedding6,
    wedding7,
    wedding8,
    wedding9,
    wedding10,
    wedding11,
    wedding12,
    wedding13,
    wedding14,
    wedding15,
    wedding16,
    wedding17,
    wedding18,
    wedding19,
    wedding20,
    wedding21,
    wedding22,
    wedding23,
    wedding24,
]